import script from "./ResetPasswordModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ResetPasswordModal.vue?vue&type=script&setup=true&lang=ts"

import "./ResetPasswordModal.vue?vue&type=style&index=0&id=259aeb04&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-259aeb04"]])

export default __exports__